import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { getModulesInTab, getSubModuleInArea } from "../../../../api/area";
import DrugInParvande from "../../sidebarArea/drug/drugInParvande";
import Libraby from "../library/libraby";
import Referral from "../referral";
import GeneralSieve from "./generalSieve";
import loadingFormAnimate from "../../../../assets/gif/loadingFormAnimate.gif";

export default function Qarbal({ selectedModule, areaId, data,dataUser, moduleErja }) {
  const [dataSubModule, setDataSubModule] = useState();
  const [selectedTab, setSelectedTab] = useState();
  const [loading, setLoading] = useState(false);
  const [subModuleDataSelected, setSubModuleDataSelected] = useState();
  useEffect(() => {
    if (areaId && selectedModule) {
      getModulesInTab(areaId, selectedModule)
        .then((x) => {
          setDataSubModule(x);
          setSelectedTab(x[0]);
        })
        .catch(() => {});
    }
  }, [areaId, selectedModule]);
  useEffect(() => {
    if (selectedTab) {
      setLoading(true);
      getSubModuleInArea(areaId, selectedTab?.moduleId)
        .then((x) => {
          setSubModuleDataSelected(x);
          setLoading(false);
        })
        .catch(() => {});
    }
  }, [selectedTab]);
  console.log(subModuleDataSelected);

  return (
    <Box
      height={"80vh"}
      sx={{
        overflow: "auto",
        "::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <Box display="flex" gap="20px">
        {dataSubModule?.map((x, i) => (
          <Typography
            onClick={() => {
              setSelectedTab(x);
            }}
            sx={{ cursor: "pointer" }}
            mt="20px"
            fontWeight="bold"
            color={
              selectedTab?.moduleName === x.moduleName
                ? "var(--emr-darkblue)"
                : "var(--emr-disable)"
            }
          >
            {x.moduleName}
          </Typography>
        ))}
      </Box>

      {loading && (
        <Box
          height={"70vh"}
          display="flex"
          justifyContent={"center"}
          alignItems="center"
          // bgcolor={""}
        >
          <img src={loadingFormAnimate} />
        </Box>
      )}

      {!loading && (
        <>
          {subModuleDataSelected?.subModules?.map((x) => (
            <Box>
              <GeneralSieve
                areaId={areaId}
                data={x}
                moduleId={selectedTab?.moduleId}
              />
            </Box>
          ))}
          {subModuleDataSelected?.isReferral && <Referral data={dataUser} />}
          {subModuleDataSelected?.canSuggestExperiment && (
            <Libraby areaId={areaId} moduleId={selectedTab?.moduleId} />
          )}
          {subModuleDataSelected?.canSuggestDrug && (
            <DrugInParvande areaId={areaId} moduleId={selectedTab?.moduleId} />
          )}
        </>
      )}
    </Box>
  );
}
